<template>
  <div id="login">

    <div style="width: 100%;height: 100%;" class="NewLogin">
      <!-- LOGO -->
      <div class="NewLogo">
        <img :src="requestForm.logoUrl" alt="">
      </div>

      <div class="NewMainLogin">
        <!-- Swiper -->
        <div class="NewLeft">
          <div class="NewSwiper">
              <el-carousel :interval="3000" arrow="always" style="height: 100%">
                <el-carousel-item 
                  v-for="(item,index) in requestForm.backgroundVoList" 
                  :key="index" 
                  v-show="fadeSwiper" 
                  :style="{'background': `url(${item.imageUrl}) top center no-repeat`, 'background-size': 'auto 100%'}"
                >
                  <div class="SwiperText">
                    <h1 class="SwiperTitle">{{item.imageTitle}}</h1>
                    <p class="SwiperDes">
                      {{item.imageSubtitle}}
                    </p>
                  </div>
                </el-carousel-item>
              </el-carousel>
          </div>
        </div>
        <!-- Login -->
        <div class="NewRight">
          <h1>{{requestForm.systemName}}</h1>
          <div class="changeBtn" v-if="isOpenPhoneLogin">
            <span @click="changeMode('account')" :class="{ active: isActive, account: true }">账号登录</span>
            <span class="changeCenter">|</span>
            <span @click="changeMode('verification')" :class="{ active: !isActive, verification: true }">验证码登录</span>
          </div>
          <div class="changeBtn" v-else></div>
          <el-form label-width="100px" class="demo-ruleForm">
            <div v-if="isActive">
              <el-form-item>
                <el-input placeholder="请输入用户名 ( 学生证件号 )" disabled></el-input>
                <img src="../../../assets/img/login-username-icon.png" class="login-icon" />
              </el-form-item>
              <el-form-item>
                <el-input type="password" placeholder="请输入密码" disabled></el-input>
                <img src="../../../assets/img/login-password-icon.png" class="login-icon"/>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="请输入验证码" disabled></el-input>
                <img src="../../../assets/img/login-code-icon.png" class="login-icon" />
                <img :src="codeSrc" alt="" class="code-img"/>
              </el-form-item>
            </div>
            <!-- 手机号登录 -->
            <div v-else class="verification-box">
              <el-form-item>
                <el-input placeholder="请输入您的注册手机号" class="input-phone" disabled></el-input>
                <img src="../../../assets/img/icon-mobile.png" class="login-icon" />
                <span class="login-phone">+86</span>
              </el-form-item>
              <el-form-item>
                <el-input type="text" placeholder="请输入短信验证码" disabled></el-input>
                <div class="getCode"> 获取验证码 </div>
                <img src="../../../assets/img/icon-mobile-code.png" class="login-icon" />
              </el-form-item>
            </div>
            <!-- 登录按钮 -->
            <el-form-item class="loginBtn">
              <el-button type="primary">登 录</el-button>
            </el-form-item>
            <!-- 忘记密码 -- 立即注册 -->
            <div class="logoBot">
              <div>还没有账号？<span>立即注册</span></div>
              <span> 忘记密码 </span>
            </div>
          </el-form>
        </div>
      </div>
      <!-- QQ E-mail Phone -->
      <div class="CallMe">

        <el-tooltip class="item" effect="dark" placement="left" v-if="requestForm.qq.isOpen == 1 && requestForm.qq.qqlist.length > 0">
          <p slot="content" v-html="requestForm.qq.qqlist.join('<br/>')" style="line-height: 18px;"></p>
          <div class="QQ CallItem">
            <img :src="QQ_icon" alt="">
              <span>QQ</span>
          </div>
        </el-tooltip>
        <!-- <div class="QQ CallItem" v-else>
          <img :src="QQ_icon" alt="">
            <span>QQ</span>
        </div> -->

        <el-tooltip class="item" effect="dark" placement="left" v-if="requestForm.email.isOpen == 1 && requestForm.email.emailList.length > 0">
          <p slot="content" v-html="requestForm.email.emailList.join('<br/>')" style="line-height: 18px;"></p>
          <div class="E-mail CallItem">
            <img :src="E_mail_icon" alt="">
            <span>邮箱</span>
          </div>
        </el-tooltip>
        <!-- <div class="E-mail CallItem" v-else>
          <img :src="E_mail_icon" alt="">
          <span>邮箱</span>
        </div> -->


        <el-tooltip class="item" effect="dark" placement="left" v-if="requestForm.phone.isOpen == 1 && requestForm.phone.phoneList.length > 0">
          <p slot="content" v-html="requestForm.phone.phoneList.join('<br/>')" style="line-height: 18px;"></p>
          <div class="Phone CallItem">
            <img :src="Phone_icon" alt="">
            <span>电话</span>
          </div>
        </el-tooltip>
        <!-- <div class="Phone CallItem" v-else>
          <img :src="Phone_icon" alt="">
          <span>电话</span>
        </div> -->

      </div>
      <div class="copyright">
        ©1998-2023 弘成科技发展有限公司 版权所有
      </div>
    </div>

  </div>
</template>
 
<script>
import { imageCheckCodeOne } from "@/http/api.js";
import { isgetTenantSmsConfig } from "@/http/modules/notice/notice";

export default {
  data() {
    return {
      NewLOGO:require('@/assets/img/Afdt-logo.png'),
      QQ_icon:require('@/assets/img/icon-QQ.png'),
      E_mail_icon:require('@/assets/img/Icon-Email.png'),
      Phone_icon:require('@/assets/img/Icon-Tel.png'),
      fadeSwiper: false,
      isOpenPhoneLogin: false,
      isActive: true,
      codeSrc: "",
      staticLogo: require('@/assets/img/Afdt-logo.png'),
      requestForm: {
        systemName: '',
        logoUrl: '',
        isUsedLogo: 0,
        backgroundVoList: [
          {
            imageSubtitle: "支持多种考试模式，助力完成严肃性考试，包括线上和线下两种场景的，全流程的考试解决方案。",
            imageTitle: "弘成慧考平台助力严肃性考试",
            imageUrl: require('@/assets/img/Swiper.png')
          }
        ],
        qq: {
          qqlist: [],
          isOpen: '',
        },
        email: {
          emailList: [],
          isOpen: '',
        },
        phone: {
          phoneList: [],
          isOpen: '',
        }
      },
      qqlist: '',
    };
  },

  mounted() {
    this.codeSrc = `${imageCheckCodeOne}?time=${Math.random()}`;
    this.isOpenPhoneVcode();
  },
  methods: {
    /*************************
     * @this 是否开启手机验证码登录功能
     *************************/
    isOpenPhoneVcode() {
      const tenant = window.localStorage.getItem('tenant');
      isgetTenantSmsConfig({ tenant }).then((res) => {
        if (res.code == 1) {
          this.isOpenPhoneLogin = res.data.loginCheck == 1
        } 
      })

      this.requestForm.logoUrl = this.$route.query.isUsedLogo == 1 ? this.$route.query.logoUrl ? this.$route.query.logoUrl : require('@/assets/img/customDefault.png') : require('@/assets/img/customDefault.png')
      this.requestForm.systemName = this.$route.query.systemName
      this.requestForm.backgroundVoList = JSON.parse(this.$route.query.backgroundVoList).length > 0 ? JSON.parse(this.$route.query.backgroundVoList) : this.requestForm.backgroundVoList

      this.requestForm.qq = JSON.parse(this.$route.query.qq)
      this.requestForm.email = JSON.parse(this.$route.query.email)
      this.requestForm.phone = JSON.parse(this.$route.query.phone)

      this.requestForm.qq.qqlist = this.requestForm.qq.qqlist ? this.requestForm.qq.qqlist : []
      this.requestForm.email.emailList = this.requestForm.email.emailList ? this.requestForm.email.emailList : []
      this.requestForm.phone.phoneList = this.requestForm.phone.phoneList ? this.requestForm.phone.phoneList : []
    },

    /*************************
     * @this 切换登录方式
     *************************/
    changeMode(v) {
      this.isActive = v == "account";
    },
  },
};
</script>

<style lang="less" scoped>
#login {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}

// 1920 * 1080
.NewLogin {
  width: 100%;
  height: 100%;
  min-height: 920px;
  background: url("../../../assets/img/newbackground.png") top center no-repeat; 
  background-size: 100% 55%;
  .NewLogo {
    max-width: 280px;
    height: 48px;
    margin-top: 36px;
    margin-left: 48px;
    img {
      height: 48px;
      width: auto;
    }
  }
  // 中心报名框架(Swiper + Login)
  .NewMainLogin {
    width: 1440px;
    height: 760px;
    margin: 24px auto 0;
    border-radius: 8px;
    box-shadow: 0px 0px 80px 0px rgba(17,36,105,0.12);
    overflow: hidden;
    display: flex;
    // 左侧外框
    .NewLeft {
      width: 920px;
      height: 100%;
      // 轮播图外框
      .NewSwiper {
        width: 100%;
        height: 100%;
        background: #fff;

        // 轮播图
        /deep/ .el-carousel__container {
          height: 760px;

          // Swiper 切换样式修改
          .el-carousel__item.is-animating {
            opacity: 1;
            transition: opacity 2s linear !important;
          }

          .el-carousel__item {
            opacity: 0.1;
            transition: opacity 1s linear !important;
          }

          // Swiper 文字描述
          .el-carousel__item,.el-carousel__item.is-animating  {
            .SwiperText {
              padding: 40px 48px;
              box-sizing: border-box;
              position: absolute;
              bottom: 0;
              width: 100%;
              min-height: 190px;
              .SwiperTitle {
                font-size: 26px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                font-weight: bold;
                color: #FFF;
                // height: 30px;
                height: auto;
                line-height: 30px;
                text-shadow: 0px 0px 80px rgba(17,36,105,0.12), 0px 2px 6px rgba(0,0,0,0.5);
              }
              .SwiperDes {
                color: #FFF;
                font-size: 16px;
                line-height: 26px;
                margin-top: 20px;
                text-shadow: 0px 0px 80px rgba(17,36,105,0.12);
              }
            }

          }

          .el-carousel__arrow.el-carousel__arrow--left,.el-carousel__arrow.el-carousel__arrow--right  {
            display: none;
          }
        }

        // 指示器
        /deep/ .el-carousel__indicators--horizontal {
          position: absolute;
          left: auto;
          right: 16px;
          bottom: 0;
          .el-carousel__indicator--horizontal button {
            width: 4px;
            height: 4px;
            border-radius: 50%;
          }
          .el-carousel__indicator--horizontal.is-active button {
            width: 16px;
            height: 4px;
            border-radius: 2px;
          }
        }
      }
    }

    .NewRight {
      width: 520px;
      height: 100%;
      background: #FFF;
      padding: 0 70px;
      box-sizing: border-box;
      // 登录标题
      h1{
        text-align: center;
        width: 100%;
        height: 40px;
        font-size: 28px;
        font-weight: 600;
        color: #2D2F33;
        margin-top: 120px;
        margin-bottom: 52px;
        text-shadow: 0px 0px 80px rgba(17,36,105,0.12);
      }
      // 切换登录方式
      .changeBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 28px;
        .account {
          margin-right: 20px;
          color: #737780;
          font-weight: 500;
          box-shadow: 0px 0px 80px 0px rgba(17,36,105,0.12);
          cursor: pointer;
        }
        .verification {
          color: #737780;
          font-weight: 500;
          box-shadow: 0px 0px 80px 0px rgba(17,36,105,0.12);
          cursor: pointer;
        }
        .changeCenter {
          margin-right: 20px;
          color: #737780;
          font-weight: 500;
        }
        .active {
          color: #0B66E6;
          position: relative;
          cursor: pointer;
        }
        .active::after {
          content: "";
          position: absolute;
          left: 50%;
          top: auto;
          bottom: -4px;
          right: auto;
          height: 2px;
          width: 18px;
          background-color: #0b66e6;
          transform: translate(-50%);
        }
      }
      // 表单
      .el-form.demo-ruleForm {
        margin-top: 48px;
        /deep/ .el-form-item__content {
          margin-left: 0 !important;
        }

        @media screen and (max-width: 1900px) {
          .el-form-item {
            margin-bottom: 24px!important;
          }
        }

        .el-form-item {
          position: relative;
          margin-bottom: 34px;
          .input-phone /deep/ .el-input__inner {
            border: 0 !important;
            border-bottom: 1px solid #e6e9f2 !important;
            background: transparent;
            border-radius: 0;
            width: 100%;
            height: 40px;
            padding: 8px 30px 8px 74px !important;
            line-height: 24px;
          }
          .login-icon {
            width: 24px;
            height: 24px;
            position: absolute;
            top: 8px;
            left: 6px;
            color: #c2c6cc;
          }
          .login-phone {
            width: 24px;
            height: 40px;
            color: #333 !important;
            position: absolute;
            left: 32px;
            color: #c2c6cc;
          }
          i {
            position: absolute;
            top: 14px;
            left: 10px;
            color: #c2c6cc;
          }
          /deep/ .el-input {
            width: 100%;
            height: 40px;
            line-height: 40px;
          }
          /deep/ .el-input__inner {
            border: 0 !important;
            border-bottom: 1px solid #e6e9f2 !important;
            background: transparent;
            border-radius: 0;
            width: 100%;
            height: 40px;
            padding: 8px 30px 8px 34px !important;
            line-height: 24px;
          }
          /deep/ .el-input__inner:focus {
            border-bottom: 1px solid #c2c6cc !important;
          }
          .code-img {
            position: absolute;
            top: 8px;
            right: 10px;
            width: 80px;
            height: 30px;
          }
          /deep/ .el-button--primary {
            span {
              font-size: 20px;
            }
            width: 100%;
            height: 48px;
            border-radius: 26px;
          }
          /deep/ .el-button--primary:hover {
            background-color: #2680ff;
          }
        }
        /* ***** 获取验证码按钮样式 ***** */
        .isgetCode {
          text-align: right;
          font-size: 14px;
          line-height: 20px;
          width: 84px;
          height: 20px;
          position: absolute;
          right: 12px;
          top: 10px;
          color: #006aff;
          cursor: pointer;
        }
        .getCode {
          text-align: right;
          font-size: 14px;
          line-height: 20px;
          width: 84px;
          height: 20px;
          position: absolute;
          right: 12px;
          top: 10px;
          color: #9299a6;
          cursor: not-allowed;
        }
        // 提交按钮
        .loginBtn {
          margin-top: 48px;
        }
        .logoBot {
          display: flex;
          justify-content: space-between;
          color: #9299a6;
          font-size: 14px;
          span {
            color: #006aff;
            cursor: pointer;
          }
        }
      }
    }
  }
}

// QQ E-mail Phone 固定定位
.CallMe {
  width: 64px;
  // height: 228px;
  height: auto;
  position: fixed;
  right: 16px;
  bottom: 160px;
  background: #FFFFFF;
  box-shadow: 0px 0px 24px 0px rgba(15,34,102,0.08);
  border-radius: 4px;
  .CallItem {
    width: 100%;
    height: 76px;
    padding-top: 16px;
    box-sizing: border-box;
    img {
      display: block;
      width: 24px;
      height: 24px;
      margin: 0 auto;
    }
    span {
      width: 100%;
      display: block;
      color: #9299A6;
      font-size: 14px;
      line-height: 20px;
      margin-top: 8px;
      text-align: center;
    }
  }
  .CallItem:hover {
    span {
      color: #006aff;
      font-weight: 700;
    }
  }
}

@media screen and (max-width: 3199px) {
  .NewLogin {
    height: auto;
    min-height: 780px;
    .NewMainLogin {
      width: 1180px;
      height: 620px;
      margin-top: 24px;
      .NewLeft {
        width: 740px;
        height: 100%;
        .NewSwiper {
          /deep/ .el-carousel__container {
            height: 620px;
          }
        }
      }
      .NewRight {
        width: 440px;
        padding: 0 56px;
        h1 {
          margin-top: 60px;
        }
      }
    }
  }
}

// 登录框媒体查询
@media screen and (max-width: 1370px) {
  .NewLogin {
    min-height: 640px;

    .NewLogo {
      max-width: 280px;
      height: 48px;
      margin-top: 16px;
      margin-left: 36px;

    }

    .NewMainLogin {
      width: 1024px;
      height: 560px;
      margin-top: 16px;
      .NewLeft {
        width: 600px;
        height: 100%;
        // 轮播图外框
        .NewSwiper {
          /deep/ .el-carousel__container {
            height: 560px;
          }
        }
      }
      .NewRight {
        width: 424px;
        padding: 0 56px;
        h1  {
          margin-top: 48px;
          margin-bottom: 36px;
        }
        .el-form.demo-ruleForm {
          margin-top: 36px;
        }
      }
    }
  }
}

.copyright {
  margin: 0 auto;
  padding: 24px 0;
  font-size: 14px;
  color: #9299a6;
  text-align: center;
  // position: absolute;
  // left: 50%;
  // bottom: 24px;
  // transform: translateX(-50%);
}
</style>
